module.exports = __webpack_public_path__ + "media/images/make_it_easy_text-2039ae255f6cc22c21407f802cf298cd.png";